// import './App.css';
import React, { useState, createContext, useEffect, useMemo } from 'react';
// import { OpenCvProvider, useOpenCv } from 'opencv-react'

// import ReactGA from 'react-ga';

// import 'antd/es/style/themes/default.less';
import 'antd/dist/reset.css'; // Import Ant Design styles by less entry
import { ConfigProvider } from 'antd';
import { storeUTMParams } from './helpers/utmTracking';
import { antdLocale } from './i18n';
import ImageToSvg from './pages/Converter/index';
import SvgEditor from "./pages/SvgEditor/index";
// import ColoringPageToSvg from "./pages/ColoringPageToSvg";


// const TRACKING_ID = "UA-216085191-1"; // YOUR_OWN_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);

export const AppContext = createContext({
  svgStore: undefined,
  setSvgStore: () => { },
});


function App() {

  const [rerender, setRerender] = useState(1);
  const [svgStore, setSvgStore] = useState();

  const [file, setFile] = useState("")
  const [colors, setColors] = useState([])
  const [crop, setCrop] = useState({
    unit: 'px', // Can be 'px' or '%'
    x: null,
    y: null,
    width: null,
    height: null
  })

  const svgValue = useMemo(
    () => ({ svgStore, setSvgStore }),
    [svgStore]
  );


  // useEffect(() => {
  //   ReactGA.pageview(window.location.pathname);
  // });

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight
});

const setDimension = () => {
    getDimension({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
    })
}


useEffect(() => {
    window.addEventListener('resize', setDimension);

    return (() => {
        window.removeEventListener('resize', setDimension);
    })
}, [screenSize])

// Initialize UTM tracking on app load
useEffect(() => {
    storeUTMParams();
}, []);



  return (
    <ConfigProvider locale={antdLocale}>
      <AppContext.Provider value={svgValue}>

        <div>
          <div hidden={svgStore !== undefined && screenSize.dynamicWidth > 750}>
            <ImageToSvg />
          </div>
          {svgStore !== undefined && screenSize.dynamicWidth > 750 &&
            <div>
             <SvgEditor />
            </div>
          }
        </div>
      </AppContext.Provider>
    </ConfigProvider>

  );
}

export default App;
